import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';

@Injectable({
  providedIn: 'root'
})
export class CatEmployeeJobService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatEmployeeJob/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatEmployeeJob/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatEmployeeJob/List`)
      .pipe(
        map((resp:any)=> resp.filter(job=> job.activeId))
      );
  }
  getCommissionGroup=()=> {
    return this.http.get(`${this.url}/CatEmployeeJob/ListCommissionGroup`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getByCommissionGroup=(commissionGroupId:number)=> {
    return this.http.get(`${this.url}/CatEmployeeJob/ListByCommissionGroup?commissionGroupId=${commissionGroupId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  save=(job:CatEmployeeJobModel)=> {
    return this.http.post(`${this.url}/CatEmployeeJob/SaveUpdate`, job)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(job:CatEmployeeJobModel)=> {
    return this.http.post(`${this.url}/CatEmployeeJob/SaveUpdate/${job.employeeJobId}`, job)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  upload=(userName: string, file: File, replace: boolean)=> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'catEmployeeJob');
    formData.append('replace', String(replace));
    formData.append('userId', localStorage.getItem('com_token'));
    return this.http.post(`${this.url}/upload/save`, formData)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  downloadLayout = () => this.http.get(`${this.url}/CatEmployeeJob/DownloadLayout`, { responseType: 'blob' });
}
